import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoDestino } from '../_models/producto-destino';

@Injectable({
  providedIn: 'root'
})
export class ProductoDestinoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosDestinos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoDestino[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoDestino[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoDestino[] ) );
  }

  listadoPorProductoIndicadorAnalizamos( idProducto: string, indicadorAnalizamos: boolean ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/indicadorAnalizamos/' + indicadorAnalizamos + '/enabled' ).pipe( map( res => res as ProductoDestino[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoDestino ) );
  }

  crear( regCrear: ProductoDestino ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoDestino ) );
  }

  actualizar( regActualizar: ProductoDestino ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoDestino[] ) {
    regActualizar.map( ( s: ProductoDestino ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }

  listDestinosSimulador() {
    return this.httClient.get( this.rutServicio + '/' + 'destinosUsadosProductos' ).pipe( map( res => res as any[] ) );
  }

  listDestinoOcupacion( idOcupacion: string ) {
    return this.httClient.get( this.rutServicio + '/tipoOcupacion/' + idOcupacion + '/destinos/enabled' ).pipe( map( res => res as any[] ) );
  }
}
